import { Injectable, inject } from '@angular/core';
import {
  Firestore,
  collection,
  doc,
  query,
  setDoc,
  updateDoc,
  where,
} from 'firebase/firestore';
import { FirebaseService } from '../../_firebase/firebase.service';
import { Observable, from, map } from 'rxjs';
import { Utilisateur } from '../../_interfaces/utilisateur';

@Injectable({
  providedIn: 'root'
})
export class UtilisateurService {
  private firebase: FirebaseService = inject(FirebaseService);
  private firestore: Firestore = this.firebase.firestore;
  private utilisateursCol = collection(this.firestore, 'utilisateurs');

  readAllUtilisateurs(): Observable<Utilisateur[]> {
    return this.firebase.collectionData(this.utilisateursCol, { idField: 'key' }) as Observable<Utilisateur[]>;
  }

  readUtilisateurByUid(uid: string): Observable<Utilisateur> {
    const userRef = doc(this.firestore, 'utilisateurs', uid);
    return this.firebase.docData(userRef, { idField: 'key' }).pipe(
      map(data => {
        if (!data) {
          throw new Error(`Aucun utilisateur trouvé avec l'UID: ${uid}`);
        }
        return data as Utilisateur;
      })
    );
  }

  utilisateurExistWithMail(email: string): Observable<boolean> {
    const q = query(this.utilisateursCol, where('email', '==', email));
    return from(this.firebase.getDocs(q)).pipe(map(snapshot => !snapshot.empty));
  }

  createUtilisateur(utilisateur: Utilisateur): Promise<void> {
    const userRef = doc(this.firestore, 'utilisateurs', utilisateur.uid);
    return setDoc(userRef, {
      email: utilisateur.email,
      firstName: utilisateur.firstName,
      lastName: utilisateur.lastName,
      uid: utilisateur.uid,
      role: utilisateur.role,
      disabled: false
    });
  }

  updateRole(uid: string, role: 'admin' | 'user'): Promise<void> {
    const userRef = doc(this.firestore, 'utilisateurs', uid);
    return updateDoc(userRef, { role });
  }

  setDisabled(uid: string, disabled: boolean): Promise<void> {
    const userRef = doc(this.firestore, 'utilisateurs', uid);
    return updateDoc(userRef, { disabled });
  }
}
